import { Badge, Stack, Switch, Typography } from '@mui/material'
import moment from 'moment'
import type React from 'react'
import date from 'src/exShared/util/date'
import type { TBaseFormRowProps } from './EditSchedule'

const ScheduleActivenessRow: React.FC<TBaseFormRowProps> = ({
  setFieldValue,
  values: { isActive, endReportDate },
}) => {
  const isDisabled: boolean = endReportDate
    ? date.isBeforeNow(moment(endReportDate).toDate())
    : false

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setFieldValue('isActive', event.target.checked)
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Switch
        checked={isActive}
        disabled={isDisabled}
        onChange={handleChange}
      />
      <Stack direction="row" spacing={1} alignItems="center">
        {isActive ? (
          <>
            <Badge variant="dot" color="success" />
            <Typography variant="body2" color="success.main" fontWeight="bold">
              アクティブ
            </Typography>
          </>
        ) : (
          <>
            <Badge color="secondary" variant="dot" />
            <Typography variant="body2" color="text.secondary">
              停止中
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  )
}

export default ScheduleActivenessRow
